module.exports = __webpack_public_path__ + "static/img/9.7733f34.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/zh/9.png
// module id = 4MSm
// module chunks = 0